<template>
  <div class="row status_table">
    <div class="col-12 profile_status_header">{{ getTranslations.home_profile_profile_stats_your_status }}</div>
    <div class="col-4 status_value"><span>{{ numberFormatting(userDetails.level) }}</span></div>
    <div class="col-4 status_value"><span>{{ numberFormatting(userDetails.totalPointsEarned) }}</span></div>
    <div class="col-4 status_value"><span>{{ numberFormatting(userDetails.availableCoins) }}</span></div>
    <div class="col-4 status_attribute">{{ getTranslations.home_profile_profile_level }}</div>
    <div class="col-4 status_attribute">{{ getTranslations.home_profile_profile_points }}</div>
    <div class="col-4 status_attribute">{{ getTranslations.home_profile_profile_game_coins }}</div>
    <div class="col-4 status_value"><span>{{ numberFormatting(userDetails.gamesPlayed) }}</span></div>
    <div class="col-4 status_value"><span>{{ numberFormatting(userDetails.gamesWon) }}</span></div>
    <div class="col-4 status_value"><span>{{ userDetails.wonPrizes.length }}</span></div> <!-- todo change -->
    <div class="col-4 status_attribute">{{ getTranslations.home_profile_profile_games }}</div>
    <div class="col-4 status_attribute">{{ getTranslations.home_profile_profile_games_won }}</div>
    <div class="col-4 status_attribute">{{ getTranslations.home_profile_profile_prizes_won }}</div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';

export default {
  name: 'profile-stats',
  mixins: [NumbersFormattingMixin],
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/ProfileStats.vue